var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpanaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 29,
    viewBox: "0 0 130 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9969 3.57467H35.047V9.74062H46.1873V12.8873H35.047V19.784H47.3206V22.9625H31.2256V0.39624H46.9969V3.57467ZM60.166 22.9623L56.2151 17.0507L52.1669 22.9623H48.3132L54.2071 14.6034L48.8314 7.00718H52.7177L56.2475 12.1243L59.7127 7.00718H63.5663L58.2555 14.4761L64.117 22.9623H60.166ZM80.9775 14.9529C80.9775 20.1018 77.9012 23.3755 73.7558 23.3755C71.4565 23.3755 69.7725 22.5491 68.6714 21.1189V28.6038H65.1092V7.00718H68.4123V9.26379C69.5133 7.57923 71.2943 6.56219 73.788 6.56219C77.9331 6.56219 80.9775 9.86766 80.9775 14.9529ZM77.3506 14.9529C77.3506 11.7111 75.6991 9.5497 73.0437 9.5497C70.3883 9.5497 68.51 11.5838 68.51 14.9529C68.51 18.322 70.4855 20.3561 73.0437 20.3561C75.6019 20.3561 77.3506 18.2584 77.3506 14.9529ZM96.5726 12.0606V22.9623H93.3665V21.1506C92.3302 22.6127 90.4843 23.4709 87.9908 23.4709C84.8819 23.4709 82.1617 22.1996 82.1617 18.9577C82.1617 15.2708 85.5942 14.0632 89.4481 13.3639L93.1722 12.6963V12.1243C93.1722 10.3761 91.8444 9.39084 89.8043 9.39084C87.6344 9.39084 86.3714 10.2808 84.5904 12.0288L82.356 9.9947C84.3639 7.64265 86.6629 6.49855 89.7071 6.49855C94.2409 6.49855 96.5726 8.78697 96.5726 12.0606ZM93.1722 16.7011V15.2391L90.3547 15.8111C87.5696 16.3832 85.6591 16.9552 85.6591 18.7671C85.6591 19.9747 86.7278 20.674 88.5088 20.674C90.9375 20.674 93.1722 19.4027 93.1722 16.7011ZM112.837 12.0288V22.9623H109.275V13.1095C109.275 10.7574 108.076 9.48629 105.907 9.48629C103.737 9.48629 102.247 11.0436 102.247 13.2049V22.9625H98.6851V7.00741H101.988V8.94629C103.025 7.389 104.773 6.499 107.008 6.499C110.862 6.499 112.837 8.8822 112.837 12.0288ZM128.945 12.0606V22.9623H125.738V21.1506C124.702 22.6127 122.856 23.4709 120.363 23.4709C117.254 23.4709 114.534 22.1996 114.534 18.9577C114.534 15.2708 117.966 14.0632 121.82 13.3639L125.544 12.6963V12.1243C125.544 10.3761 124.216 9.39084 122.176 9.39084C120.006 9.39084 118.743 10.2808 116.962 12.0288L114.728 9.9947C116.736 7.64265 119.035 6.49855 122.079 6.49855C126.613 6.49855 128.945 8.78697 128.945 12.0606ZM125.544 16.7011V15.2391L122.727 15.8111C119.942 16.3832 118.031 16.9552 118.031 18.7671C118.031 19.9747 119.1 20.674 120.881 20.674C123.31 20.674 125.544 19.4027 125.544 16.7011Z",
    fill: "#002115"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5812 14.2933C12.8603 14.2933 13.8971 13.2565 13.8971 11.9774C13.8971 10.6983 12.8603 9.66138 11.5812 9.66138C10.3021 9.66138 9.2652 10.6983 9.2652 11.9774C9.2652 13.2565 10.3021 14.2933 11.5812 14.2933Z",
    fill: "#21FF49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5812 23.5538C12.8603 23.5538 13.8971 22.5169 13.8971 21.2378C13.8971 19.9587 12.8603 18.9219 11.5812 18.9219C10.3021 18.9219 9.2652 19.9587 9.2652 21.2378C9.2652 22.5169 10.3021 23.5538 11.5812 23.5538Z",
    fill: "#21FF49"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31599 14.2933C3.59508 14.2933 4.63197 13.2565 4.63197 11.9774C4.63197 10.6983 3.59508 9.66138 2.31599 9.66138C1.0369 9.66138 0 10.6983 0 11.9774C0 13.2565 1.0369 14.2933 2.31599 14.2933Z",
    fill: "#21FF49"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5812 5.02821C12.8603 5.02821 13.8971 3.99132 13.8971 2.71223C13.8971 1.43314 12.8603 0.39624 11.5812 0.39624C10.3021 0.39624 9.2652 1.43314 9.2652 2.71223C9.2652 3.99132 10.3021 5.02821 11.5812 5.02821Z",
    fill: "#21FF49"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8464 14.2933C22.1254 14.2933 23.1623 13.2565 23.1623 11.9774C23.1623 10.6983 22.1254 9.66138 20.8464 9.66138C19.5672 9.66138 18.5304 10.6983 18.5304 11.9774C18.5304 13.2565 19.5672 14.2933 20.8464 14.2933Z",
    fill: "#21FF49"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31599 5.02821C3.59508 5.02821 4.63197 3.99132 4.63197 2.71223C4.63197 1.43314 3.59508 0.39624 2.31599 0.39624C1.0369 0.39624 0 1.43314 0 2.71223C0 3.99132 1.0369 5.02821 2.31599 5.02821Z",
    fill: "#21FF49"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8464 5.02821C22.1254 5.02821 23.1623 3.99132 23.1623 2.71223C23.1623 1.43314 22.1254 0.39624 20.8464 0.39624C19.5672 0.39624 18.5304 1.43314 18.5304 2.71223C18.5304 3.99132 19.5672 5.02821 20.8464 5.02821Z",
    fill: "#21FF49"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8464 23.5538C22.1254 23.5538 23.1623 22.5169 23.1623 21.2378C23.1623 19.9587 22.1254 18.9219 20.8464 18.9219C19.5672 18.9219 18.5304 19.9587 18.5304 21.2378C18.5304 22.5169 19.5672 23.5538 20.8464 23.5538Z",
    fill: "#21FF49"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6036 14.3034C11.3572 14.3034 11.12 14.2645 10.8972 14.1934L9.36102 20.6701C9.61902 19.6722 10.525 18.9353 11.6034 18.9353C12.6817 18.9353 13.5877 19.6722 13.8458 20.6701L12.3096 14.1934C12.0867 14.2647 11.85 14.3034 11.6036 14.3034Z",
    fill: "url(#paint0_linear_26579_787)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27937 11.9854C9.27937 11.7389 9.31829 11.5018 9.38938 11.279L2.91272 9.7428C3.91045 10.0008 4.6474 10.9068 4.6474 11.9851C4.6474 13.0635 3.91045 13.9695 2.91272 14.2274L9.38938 12.6912C9.31805 12.4685 9.27937 12.2318 9.27937 11.9854Z",
    fill: "url(#paint1_linear_26579_787)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6031 9.66609C11.8496 9.66609 12.0867 9.70499 12.3096 9.7761L13.8458 3.29944C13.5877 4.29716 12.6817 5.03412 11.6034 5.03412C10.525 5.03412 9.61902 4.29716 9.36102 3.29944L10.8972 9.7761C11.12 9.70476 11.3567 9.66609 11.6031 9.66609Z",
    fill: "url(#paint2_linear_26579_787)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9072 11.9849C13.9072 12.2313 13.8683 12.4685 13.7972 12.6912L20.2739 14.2274C19.2761 13.9695 18.5391 13.0635 18.5391 11.9851C18.5391 10.9068 19.2761 10.0008 20.2739 9.7428L13.7972 11.279C13.8686 11.5018 13.9072 11.7385 13.9072 11.9849Z",
    fill: "url(#paint3_linear_26579_787)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.398 9.99818L4.22402 1.3783C4.86532 2.28246 4.78148 3.54329 3.97135 4.35342C3.16122 5.16355 1.90062 5.24739 0.99646 4.60632L9.61611 10.7801C9.80996 10.4607 10.0786 10.192 10.398 9.99818Z",
    fill: "url(#paint4_linear_26579_787)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.573 10.7801L22.1928 4.60608C21.2887 5.24739 20.0278 5.16355 19.2178 4.35319C18.4076 3.54305 18.3237 2.28246 18.9649 1.3783L12.7911 9.99794C13.1105 10.1918 13.3792 10.4607 13.573 10.7801Z",
    fill: "url(#paint5_linear_26579_787)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7911 13.9597L18.965 22.5796C18.3237 21.6754 18.4076 20.4146 19.2178 19.6045C20.0278 18.7943 21.2885 18.7105 22.1926 19.3515L13.573 13.1779C13.3792 13.4972 13.1105 13.7658 12.7911 13.9597Z",
    fill: "url(#paint6_linear_26579_787)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61633 13.1779L0.99646 19.3518C1.90062 18.7105 3.16145 18.7943 3.97158 19.6046C4.78172 20.4148 4.86555 21.6754 4.22448 22.5796L10.3982 13.9599C10.0788 13.766 9.81019 13.4972 9.61633 13.1779Z",
    fill: "url(#paint7_linear_26579_787)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31599 23.5538C3.59508 23.5538 4.63197 22.5169 4.63197 21.2378C4.63197 19.9587 3.59508 18.9219 2.31599 18.9219C1.0369 18.9219 0 19.9587 0 21.2378C0 22.5169 1.0369 23.5538 2.31599 23.5538Z",
    fill: "#21FF49"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26579_787",
    x1: 11.6036,
    y1: 20.6701,
    x2: 11.6036,
    y2: 14.1934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21FF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21FF49",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26579_787",
    x1: 2.91272,
    y1: 11.9854,
    x2: 9.38938,
    y2: 11.9854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21FF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21FF49",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26579_787",
    x1: 11.6031,
    y1: 3.29944,
    x2: 11.6031,
    y2: 9.7761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21FF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21FF49",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26579_787",
    x1: 20.2739,
    y1: 11.9849,
    x2: 13.7972,
    y2: 11.9849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21FF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21FF49",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26579_787",
    x1: 2.61034,
    y1: 2.99239,
    x2: 10.0073,
    y2: 10.3893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21FF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21FF49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26579_787",
    x1: 20.5787,
    y1: 2.99238,
    x2: 13.1819,
    y2: 10.3893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21FF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21FF49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26579_787",
    x1: 20.5788,
    y1: 20.9658,
    x2: 13.1819,
    y2: 13.5688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21FF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21FF49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26579_787",
    x1: 2.61057,
    y1: 20.9656,
    x2: 10.0075,
    y2: 13.5686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21FF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21FF49",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpanaLogo);
export default __webpack_public_path__ + "static/media/expanaLogo.c0fa461b1a44bac648d4cf9ce46fe4cd.svg";
export { ForwardRef as ReactComponent };